<template>
	<card v-bind="cardProps">
		<card-title small>{{ purchase.product.name }}</card-title>

		<card-text>
			<description-list small>
				<description-list-item v-if="purchase.status.title" :title="$t('label.status')">
					<template #text>
						<chip :color="purchase.status.color" small :help="purchase.sub_status && purchase.sub_status.description ? purchase.sub_status.description : null">

							{{ purchase.status.title }}

						</chip>
					</template>
				</description-list-item>
				<description-list-item :title="$t('label.quantity')" :text="purchase.quantity"/>
				<description-list-item v-if="purchase.country_code" :title="$t('label.delivery_address')">
					<template #text>
						<div class="flex flex-column">
							<span v-if="purchase.receiver_name">{{ purchase.receiver_name }}</span> <span v-if="purchase.street">{{ purchase.street }}</span> <span
							v-if="purchase.city">{{ purchase.postcode + ' ' + purchase.city }}</span> <span v-if="purchase.country_code">
                        <span v-if="purchase.state_code">{{ purchase.state_code.toUpperCase() }}</span>
                        <span v-if="purchase.country_code">{{ purchase.country_code.toUpperCase() }}</span>
                    </span>
						</div>
					</template>
				</description-list-item>
				<template v-if="purchase.inputs && purchase.inputs.length">
					<template v-for="(input, inputKey) in purchase.inputs" :key="inputKey">
						<description-list-item v-if="input.label" :title="input.label">
							<template #text>
								<lazy-dynamic-input-value :input="input" :value="input.value">
								</lazy-dynamic-input-value>
							</template>
						</description-list-item>
					</template>
				</template>
				<description-list-item :title="$t('label.order_number')" :text="purchase.order_id ? purchase.order_id : '-'" :to="orderTo" :color="orderTo ? event.color : null"/>
				<description-list-item :title="$t('label.booking_date')">
					<template #text>
						<dynamic-date :date="purchase.created_at" time>
						</dynamic-date>
					</template>
				</description-list-item>
				<description-list-item v-if="purchase.deleted_at" :title="$t('label.cancel_date')" :text="$date(purchase.deleted_at).format('DD. MMM. YYYY HH:mm')"/>
			</description-list>
		</card-text>

		<card-buttons v-if="$slots.buttons" grow break-column="sm">
			<slot name="buttons"/>
		</card-buttons>
	</card>
</template>

<script>
import CardMixin from "../Card/CardMixin";


export default {
	name: 'EventProductPurchase',

	mixins: [CardMixin],

	props: {
		purchase: {
			type: Object,
			required: true
		},

		// The event the product was purchased for
		event: {
			type: Object,
			required: true
		},

		divided: {
			type: Boolean,
			default: false
		},

		// A route target to redirect the user when he clicks on the order number
		orderTo: {
			type: [Object, String],
			default: null
		}
	},

	computed: {
		product() {
			return this.purchase.product;
		}
	}
}
</script>